<template>
    <div class="d-flex flex-column light" style="height: 100vh">
        <NavbarDefault />
        <div class="background-container bg-body-tertiary flex-grow-1 overflow-hidden">
            <div class="d-flex justify-content-center align-items-stretch w-100 h-100 py-md-4">
                <div class="my-md-5 flex-grow-1" style="max-width: 550px;">
                    <NuxtPage />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.background-container {
    background-image: url('/helikopters.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
</style>
